import React, { useEffect, useState } from 'react';
import { showPopup }    from './helpers';
import { addCommas }    from './helpers';
import './index.css';
import PropertyDetails  from './PropertyDetails';
import EstimatedCosts   from './EstimatedCosts';


const App = () => {

  const [formData, setFormData] = useState({
    purchasePrice: 1500000,
    amountFinancedPrecent: 0.8,
    amountFinancedDollar: 0,
    propertyType: '1',
    bayerAttorneyFee: 3500,
    moveInDeposit: 1000,
    titleSearch: 600,
    boardApplicationFee: 500,
    moveInFee: 500,
    surveyFee: 300,
    titleSearchEndorsement: 250,
    deedRecordingFee: 200,
    lienSearchFee: 0,
    creditCheck: 100,

    mortgageRecordingTax: 1.54,
    mortgagePolicyPremium: 0.12,
    bankAttorneyFee: 1000,
    loanApplicationFee: 1000,
    appraisalFee: 750,
    mortgageRecordingFee: 200,
    recognitionAgreementFee: 0,
    ucc1FilingFee: 0,

    sponsorAttorneyFee: 0,

    newConstruction: false,
    
  });

  const [ isFee, setIsFee ] = useState({
    mansionTax: 0,
    titleInsurance: 0.45,
  });

  const [ userParams, setUserParams ] = useState({
    email: '',
    
    purchasePrice: 0,
    amountFinancedDollar: 0,
    amountFinancedPrecent: 0,
    propertyType: 0,
    newConstruction: false,

    mansionTax: 0,
    bayerAttorneyFee: 0,
    moveInDeposit: 0,
    titleSearch: 0,
    boardApplicationFee: 0,
    moveInFee: 0,
    surveyFee: 0,
    titleSearchEndorsement: 0,
    deedRecordingFee: 0,
    lienSearchFee: 0,
    creditCheck: 0,

    mortgageRecordingTax: 0,
    mortgagePolicyPremium: 0,
    bankAttorneyFee: 0,
    loanApplicationFee: 0,
    appraisalFee: 0,
    mortgageRecordingFee: 0,
    recognitionAgreementFee: 0,
    ucc1FilingFee: 0,

    sponsorAttorneyFee: 0,
    NYCtransferTaxPrice: 0,
    NYCtransferTaxPercent: 0,
    NYstateTransferTaxPrice: 0,
    NYstateTransferTaxPercent: 0,

    total: 0,
  });

  // Bayer fee
  const [ attorneyFeePercent,     setAttorneyFeePercent ]     = useState(0);
  const [ nyTransferTaxRate,      setNyTransferTaxRate ]      = useState(0);
  const [ nyTransferTaxCost,      setNyTransferTaxCost ]      = useState(0);
  const [ nyStateTransferTaxRate, setNyStateTransferTaxRate ] = useState(0);
  const [ nyStateTransferTaxCost, setNyStateTransferTaxCost ] = useState(0);
  const [ isCost,                 setIsCost ]                 = useState(0);

  const getPropertyType = (type) => {
    let property = 'Condo';
    switch (type) {
      case '1':
        return property = 'Condo';
      case '2':
        return property = 'Co-op';
      case '3':
        return property = 'House';
      case '4':
        return property = '4 Family House';
      case '5':
        return property = '5 or More Family House';
      case '6':
        return property = 'Commercial Real Estate';
      default:
        return 'Unknown';
    }
  };

  // Email values need to be updated
  useEffect(() => {
    setUserParams(prevState => ({
      ...prevState,
    purchasePrice: addCommas(formData.purchasePrice),
    amountFinancedPrecent: formData.amountFinancedPrecent,
    amountFinancedDollar: addCommas(formData.purchasePrice * formData.amountFinancedPrecent),
    propertyType: getPropertyType(formData.propertyType),
    newConstruction: formData.newConstruction ? 'Yes' : 'No',

    mansionTax: addCommas((formData.purchasePrice * isFee.mansionTax / 100).toFixed(0)),
    mansionTaxPercent: isFee.mansionTax,
    titleInsurancePremium: addCommas((formData.purchasePrice * isFee.titleInsurance / 100).toFixed(0)),
    titleInsurancePremiumPercent: isFee.titleInsurance,
    bayerAttorneyFee: addCommas(formData.bayerAttorneyFee),
    bayerAttorneyFeePercent: attorneyFeePercent,
    moveInDeposit: formData.moveInDeposit,
    moveInDepositPercent: (formData.moveInDeposit * 100 / formData.purchasePrice).toFixed(3),
    titleSearch: formData.titleSearch,
    titleSearchPercent: (formData.titleSearch * 100 / formData.purchasePrice).toFixed(3),
    boardApplicationFee: formData.boardApplicationFee,
    boardApplicationFeePercent: (formData.boardApplicationFee * 100 / formData.purchasePrice).toFixed(3),
    moveInFee: formData.moveInFee,
    moveInFeePercent: (formData.moveInFee * 100 / formData.purchasePrice).toFixed(3),
    surveyFee: formData.surveyFee,
    surveyFeePercent: (formData.surveyFee * 100 / formData.purchasePrice).toFixed(3),
    titleSearchEndorsement: formData.titleSearchEndorsement,
    titleSearchEndorsementPercent: (formData.titleSearchEndorsement * 100 / formData.purchasePrice).toFixed(3),
    deedRecordingFee: formData.deedRecordingFee,
    deedRecordingFeePercent: (formData.deedRecordingFee * 100 / formData.purchasePrice).toFixed(3),
    lienSearchFee: formData.lienSearchFee,
    lienSearchFeePercent: (formData.lienSearchFee * 100 / formData.purchasePrice).toFixed(3),
    creditCheck: formData.creditCheck,
    creditCheckPercent: (formData.creditCheck * 100 / formData.purchasePrice).toFixed(3),

    mortgageRecordingTax: addCommas((formData.mortgageRecordingTax * formData.purchasePrice / 100).toFixed(0)),
    mortgageRecordingTaxPercent: (formData.mortgageRecordingTax),
    mortgagePolicyPremium: addCommas((formData.mortgagePolicyPremium * formData.purchasePrice / 100).toFixed(0)),
    mortgagePolicyPremiumPercent: formData.mortgagePolicyPremium,
    bankAttorneyFee: formData.bankAttorneyFee,
    bankAttorneyFeePercent: (formData.bankAttorneyFee * 100 / formData.purchasePrice).toFixed(3),
    loanApplicationFee: formData.loanApplicationFee,
    loanApplicationFeePercent: (formData.loanApplicationFee * 100 / formData.purchasePrice).toFixed(3),
    appraisalFee: formData.appraisalFee,
    appraisalFeePercent: (formData.appraisalFee * 100 / formData.purchasePrice).toFixed(3),
    mortgageRecordingFee: formData.mortgageRecordingFee,
    mortgageRecordingFeePercent: (formData.mortgageRecordingFee * 100 / formData.purchasePrice).toFixed(3),
    recognitionAgreementFee: formData.recognitionAgreementFee,
    recognitionAgreementFeePercent: (formData.recognitionAgreementFee * 100 / formData.purchasePrice).toFixed(3),
    ucc1FilingFee: formData.ucc1FilingFee,
    ucc1FilingFeePercent: (formData.ucc1FilingFee * 100 / formData.purchasePrice).toFixed(3),

    nyTransferTaxCost: addCommas(nyTransferTaxCost),
    nyTransferTaxCostPercent: nyTransferTaxRate,
    nyStateTransferTaxCost: addCommas(nyStateTransferTaxCost),
    nyStateTransferTaxCostPercent: nyStateTransferTaxRate,
    sponsorAttorneyFee: addCommas(formData.sponsorAttorneyFee),
    sponsorAttorneyFeePercent: (formData.sponsorAttorneyFee * 100 / formData.purchasePrice).toFixed(2),
    
    total: addCommas(isCost.toFixed(0)),
    totalPercent: (isCost * 100 / formData.purchasePrice).toFixed(2),

    }));
  }, [formData, isFee]);

  // Property type
  useEffect(() => {
    setUserParams(prevState => ({
      ...prevState,
      propertyType: getPropertyType(formData.propertyType)
    }))
    console.log(userParams.propertyType, ' userParams.propertyType');
  }, [formData.propertyType, userParams.propertyType]);
  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "bayerAttorneyFee" && value > setFormData.purchasePrice) {
      showPopup(`Buyer's attorney fee cannot be more than the purchase price.`);
      return; 
    }
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  // RESET
  const resetHandler = () => {
    setFormData({
      purchasePrice: 1500000,
      amountFinancedPrecent: 0.8,
      amountFinancedDollar: 0,
      propertyType: '1',
      bayerAttorneyFee: 3500,
      moveInDeposit: 1000,
      titleSearch: 600,
      boardApplicationFee: 500,
      moveInFee: 500,
      surveyFee: 300,
      titleSearchEndorsement: 250,
      deedRecordingFee: 200,
      lienSearchFee: 0,
      creditCheck: 100,
      mortgageRecordingTax: 0,
      mortgagePolicyPremium: 0.12,
      bankAttorneyFee: 1000,
      loanApplicationFee: 1000,
      appraisalFee: 750,
      mortgageRecordingFee: 200,
      recognitionAgreementFee: 350,
      ucc1FilingFee: 100,
      sponsorAttorneyFee: 0,
      newConstruction: false,
    });
    setIsFee({
      mansionTax: 1,
      mansionTaxDollar: 0,
      titleInsurance: 0.45,
  
    });
  };

  // NY City Taxes
  const calculateTransferTaxRate = () => {
    const { purchasePrice, propertyType } = formData;
    let taxRate = 0;
    let suplementTaxRate = 0;

    // suplementTaxRate Value based on table
    // if (purchasePrice >= 2000000 && purchasePrice < 3000000) {
    //     suplementTaxRate = 0.25;
    // } else if (purchasePrice >= 3000000 && purchasePrice < 5000000) {
    //     suplementTaxRate = 0.5;
    // } else if (purchasePrice >= 5000000 && purchasePrice < 10000000) {
    //     suplementTaxRate = 1.25;
    // } else if (purchasePrice >= 10000000 && purchasePrice < 15000000) {
    //     suplementTaxRate = 2.25;
    // } else if (purchasePrice >= 15000000 && purchasePrice < 20000000) {
    //     suplementTaxRate = 2.5;
    // } else if (purchasePrice >= 20000000 && purchasePrice < 25000000) {
    //     suplementTaxRate = 2.75;
    // } else if (purchasePrice >= 25000000) {
    //     suplementTaxRate = 2.9;
    // }


    if (purchasePrice <= 500000) {
      // for Residential
      if (propertyType === '1' || propertyType === '2' || propertyType === '3' || propertyType === '4') { // for Residential
        taxRate = 1.0 + suplementTaxRate;
      // for NON Residential
      } else {
        taxRate = 1.425;
      }
    } else {
      // for Residential
      if (propertyType === '1' || propertyType === '2' || propertyType === '3' || propertyType === '4') { // for Residential
        taxRate = 1.425 + suplementTaxRate;
      // for NON Residential
      } else {
        taxRate = 2.625;
      }
    }
    console.log('suplementTaxRate =', suplementTaxRate);
    console.log('taxRate =', taxRate);

    let valueCost = formData.purchasePrice * taxRate / 100;
    setNyTransferTaxCost(valueCost.toFixed(0));
    setNyTransferTaxRate(taxRate);
  };

  // NY State transfer tax
  const calculateNYStateTransferTaxRate = () => {
    const { purchasePrice, propertyType } = formData;
    let taxRate = 0;

    if (purchasePrice < 3000000) {
      if (propertyType === '1' || propertyType === '2' || propertyType === '3') {
        taxRate = 0.40;
      } else {
        taxRate = 0.40;
      }
    } else {
      if (propertyType === '1' || propertyType === '2' || propertyType === '3') {
        taxRate = 0.65;
      } else {
        taxRate = 0.65;
      }
    }
    let valueCost = formData.purchasePrice * taxRate / 100;
    setNyStateTransferTaxCost(valueCost.toFixed(0));
    setNyStateTransferTaxRate(taxRate);
  };

  // Total Seller Closing Costs
  const calculateCosts = () => {
    let mansion_tax             = formData.purchasePrice * isFee.mansionTax / 100;
    let title_insiurance        = formData.purchasePrice * isFee.titleInsurance / 100;
    let mortgage_policy_premium = formData.mortgagePolicyPremium * formData.purchasePrice / 100;
    let mortgageRecording_tax   = formData.mortgageRecordingTax * formData.purchasePrice / 100
    // let 
    let value = mansion_tax + title_insiurance + Number(formData.bayerAttorneyFee) + formData.moveInDeposit + formData.titleSearch +
                formData.boardApplicationFee + formData.moveInFee + formData.surveyFee + formData.titleSearchEndorsement + formData.deedRecordingFee + 
                formData.lienSearchFee + formData.creditCheck + mortgageRecording_tax + mortgage_policy_premium + formData.bankAttorneyFee + formData.loanApplicationFee +
                formData.appraisalFee + formData.mortgageRecordingFee + formData.recognitionAgreementFee + formData.ucc1FilingFee +
                Number(nyTransferTaxCost) + Number(nyStateTransferTaxCost) + Number(formData.sponsorAttorneyFee);
    setIsCost(value);
  };
  
  useEffect(() => {
    bayerAttorneyFeeHandler();
    calculateCosts();
  }, [formData, isCost, userParams, isFee, attorneyFeePercent, nyTransferTaxRate, nyTransferTaxCost, nyStateTransferTaxRate, nyStateTransferTaxCost]);

  // Property type CHANGE
  useEffect(() => {
    if (formData.propertyType === '1') { // COOP
      setFormData({
        ...formData,
        lienSearchFee: 0,
        deedRecordingFee: 200,
        moveInDeposit: 1000,
        titleSearch: 600,
        boardApplicationFee: 500,
        moveInFee: 500,
        titleSearchEndorsement: 250,

        mortgageRecordingTax: 1.54,
        mortgagePolicyPremium: 0.12,
        recognitionAgreementFee: 0,
        mortgageRecordingFee: 200,
        ucc1FilingFee: 0,
      });
      setIsFee({
        ...isFee,
        titleInsurance: 0.45,
      })
    }
    if (formData.propertyType === '2') { // COOP
      setFormData({
        ...formData,
        lienSearchFee: 300,
        deedRecordingFee: 0,
        moveInDeposit: 1000,
        titleSearch: 0,
        boardApplicationFee: 500,
        moveInFee: 500,
        titleSearchEndorsement: 0,

        mortgageRecordingTax: 0,
        mortgagePolicyPremium: 0,
        recognitionAgreementFee: 350,
        mortgageRecordingFee: 0,
        ucc1FilingFee: 100,
      })
      setIsFee({
        ...isFee,
        titleInsurance: 0,
      })
    }
    if (formData.propertyType === '3') { // HOUSE
      setFormData({
        ...formData,
        lienSearchFee: 0,
        deedRecordingFee: 200,
        moveInDeposit: 0,
        titleSearch: 600,
        boardApplicationFee: 0,
        moveInFee: 0,
        titleSearchEndorsement: 250,

        mortgageRecordingTax: 1.54,
        mortgagePolicyPremium: 0.12,
        recognitionAgreementFee: 0,
        mortgageRecordingFee: 200,
        ucc1FilingFee: 0,
      })
      setIsFee({
        ...isFee,
        titleInsurance: 0.45,
      })
    }
  }, [formData.propertyType]);


    // Seller power of attorney recording fee
    useEffect(() => {
      if (formData.sellerPowerOfAttorney === true) {
        setIsFee(prevState => ({
          ...prevState,
          sellerPowerAttorneyFee: 125
        }));
      }
      else {
        setIsFee(prevState => ({
          ...prevState,
          sellerPowerAttorneyFee: 0
        }));
      }
    }, [formData.sellerPowerOfAttorney, isFee.sellerPowerAttorneyFee]);

  
  // MansionTax
  useEffect(() => {  
    if (formData.purchasePrice < 1000000) {
      setIsFee(prevState => ({
        ...prevState,
        mansionTax: 0,
      }));
    } if (formData.purchasePrice >= 1000000 && formData.purchasePrice < 2000000) {
      setIsFee(prevState => ({
        ...prevState,
        mansionTax: 1,
      }));
    } else if (formData.purchasePrice >= 2000000 && formData.purchasePrice < 3000000) {
      setIsFee(prevState => ({
        ...prevState,
        mansionTax: 1.25,
      }));
    } else if (formData.purchasePrice >= 3000000 && formData.purchasePrice < 5000000) {
      setIsFee(prevState => ({
        ...prevState,
        mansionTax: 1.5,
      }));
    } else if (formData.purchasePrice >= 5000000 && formData.purchasePrice < 10000000) {
      setIsFee(prevState => ({
        ...prevState,
        mansionTax: 2.25,
      }));
    } else if (formData.purchasePrice >= 10000000 && formData.purchasePrice < 15000000) {
      setIsFee(prevState => ({
        ...prevState,
        mansionTax: 3.25,
      }));
    } else if (formData.purchasePrice >= 15000000 && formData.purchasePrice < 20000000) {
      setIsFee(prevState => ({
        ...prevState,
        mansionTax: 3.5,
      }));
    } else if (formData.purchasePrice >= 20000000 && formData.purchasePrice < 25000000) {
      setIsFee(prevState => ({
        ...prevState,
        mansionTax: 3.75,
      }));
    } else if (formData.purchasePrice >= 25000000) {
      setIsFee(prevState => ({
        ...prevState,
        mansionTax: 3.9,
      }));
    }
  }, [formData.purchasePrice]);

  // Bayer's Attorney Fee
  const bayerAttorneyFeeHandler = () => {
    let value = formData.bayerAttorneyFee * 100 / formData.purchasePrice;
    setAttorneyFeePercent(value.toFixed(3));
  };

  // All CASCH
  useEffect(() => { 
    if (formData.amountFinancedPrecent === '1') {
      setFormData({
        ...formData,
        mortgagePolicyPremium: 0,
        bankAttorneyFee: 0,
        loanApplicationFee: 0,
        appraisalFee: 0,
        mortgageRecordingFee: 0,
        recognitionAgreementFee: 0,
        ucc1FilingFee: 0,
        mortgageRecordingTax: 0,
      })
    }
    else {
      setFormData({
        ...formData,
        mortgagePolicyPremium: 0.012,
        bankAttorneyFee: 1000,
        loanApplicationFee: 1000,
        appraisalFee: 750,
        mortgageRecordingFee: 200,
        recognitionAgreementFee: 350,
        ucc1FilingFee: 100,
      })
    }
  }, [formData.amountFinancedPrecent]);

  
  // New Construction
  useEffect(() => {
    if (formData.newConstruction === true) {
      setFormData({
        ...formData,
        sponsorAttorneyFee: 3000,
      });
      calculateTransferTaxRate();
      calculateNYStateTransferTaxRate();
    }
    else {
      // set data to 0
      setFormData({
        ...formData,
        sponsorAttorneyFee: 0,
      });
      setNyStateTransferTaxCost(0);
      setNyStateTransferTaxRate(0);
      setNyTransferTaxCost(0);
      setNyTransferTaxRate(0);
    }
  }, [formData.newConstruction, formData.purchasePrice]);


  // Title Insurance - Mortgage Policy Premium
  useEffect(() => {
    if (formData.amountFinancedPrecent === '0.7' && (formData.propertyType === '1' || formData.propertyType === '3')) { // COOP
      setFormData({
        ...formData,
        mortgagePolicyPremium: 0.105,
        mortgageRecordingTax: 1.348,
      });
    }
    else if (formData.amountFinancedPrecent === '0.75' && (formData.propertyType === '1' || formData.propertyType === '3')) {  
      setFormData({
        ...formData,
        mortgagePolicyPremium: 0.113,
        mortgageRecordingTax: 1.444,
      });
    }
    else if (formData.amountFinancedPrecent === '0.8' && (formData.propertyType === '1' || formData.propertyType === '3')) {  
      setFormData({
        ...formData,
        mortgagePolicyPremium: 0.12,
        mortgageRecordingTax: 1.54,
      });
    }
    else if (formData.amountFinancedPrecent === '0.9' && (formData.propertyType === '1' || formData.propertyType === '3')) {  
      setFormData({
        ...formData,
        mortgagePolicyPremium: 0.135,
        mortgageRecordingTax: 1.733,
      });
    }
    else if (formData.amountFinancedPrecent === '0' && (formData.propertyType === '1' || formData.propertyType === '3')) {  
      setFormData({
        ...formData,
        mortgagePolicyPremium: 0.1,
        mortgageRecordingTax: 1.283,
      });
    }
    else if (formData.amountFinancedPrecent === '1' && (formData.propertyType === '1' || formData.propertyType === '3')) {  
      setFormData({
        ...formData,
        mortgageRecordingTax: 0,
        mortgagePolicyPremium: 0,
        bankAttorneyFee: 0,
        loanApplicationFee: 0,
        appraisalFee: 0,
        mortgageRecordingFee: 0,
        recognitionAgreementFee: 0,
        ucc1FilingFee: 0,
      });
    }
  }, [formData.propertyType, formData.amountFinancedPrecent]);

  return (
    <div id="app" className="container">

       <div className="row justify-content-center">
            {/* <div className="col-12 text-center pb-4">
              <h2>Buyer Closing Cost Calculator</h2>
            </div>
            <div className='w-100'></div> */}

          <PropertyDetails 
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
            resetHandler={resetHandler}
            userParams={userParams} 
            setUserParams={setUserParams}
          />
          <EstimatedCosts 
            formData={formData}
            nyTransferTaxRate={nyTransferTaxRate}
            nyTransferTaxCost={nyTransferTaxCost}
            nyStateTransferTaxRate={nyStateTransferTaxRate}
            nyStateTransferTaxCost={nyStateTransferTaxCost}
            attorneyFeePercent={attorneyFeePercent}
            isFee={isFee}
            setIsFee={setIsFee}
            isCost={isCost}
            setIsCost={setIsCost}
            setFormData={setFormData}
            handleChange={handleChange}
            resetHandler={resetHandler}
            userParams={userParams} 
            setUserParams={setUserParams}
          />
          
          <div className='w-100'></div>
          {/* Popup */}
          <div className='col-12 col-md-10 col-lg-8'>
            <div id="popup" className="popup"></div>
          </div>
      </div>
    </div>
  );
}

export default App;
